import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardQuickActionDialogComponent } from '../dashboard-quick-action-dialog/dashboard-quick-action-dialog.component';

@Component({
  selector: 'app-dashboard-actions',
  templateUrl: './dashboard-actions.component.html',
  styleUrl: './dashboard-actions.component.scss',
})
export class DashboardActionsComponent {
  constructor(private dialog: MatDialog) {}

  openQuickActionDialog(): void {
    this.dialog.open(DashboardQuickActionDialogComponent, { width: '1600px' });
  }

  openRegisterShoppingDialog(): void {
    // this.dialog.open(RegisterShoppingDialogComponent, { width: '1600px' });
  }

  openStockLookupDialog(): void {
    // this.dialog.open(StockLookupDialogComponent, { width: '1600px' });
  }
}
